<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Tax id configuration</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>PAN card number</mat-label>
        <input  matInput [(ngModel)]="taxData.pan_number"/>
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>TAN number</mat-label>
        <input  matInput [(ngModel)]="taxData.tan_number"/>
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>GST number</mat-label>
        <input  matInput [(ngModel)]="taxData.gst_number"/>
       
      </mat-form-field>
    </div>
 
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close
  
    >
      Cancel
    </button>
    <button
      
      mat-flat-button
      color="accent"
 
      (click)="onPost()"
      
    >
    Confirm
    </button>

  </mat-dialog-actions>
  